'use client'

import { SidebarLayout } from '../components/sidebar-layout'
import { AppNavBar } from './AppNavBar'
import { AppSideMenu } from './AppSideMenu'


export function AppLayout({ events, children }) {
    return (
        <SidebarLayout
            navbar={
                <AppNavBar></AppNavBar>
            }
            sidebar={
                <AppSideMenu></AppSideMenu>
            }
        >
            {children}
           
        </SidebarLayout>
    )
}
